import apiClient from './apiClient';
import { setIdleMinutes } from './utils/activity';

// Is the user still logged in? /check is left out of the automatic refresh of apiClient (it is
// polled every 30 s), so an expired access token is refreshed here before giving up: without
// it the user was logged out as soon as the access token (60 min from login) ran out, even
// with a valid refresh token. Network errors are not "logged out" (the caller skips them).
const checkAuth = async () => {
    try {
        const response = await apiClient.get('/check');
        setIdleMinutes(response.data?.session_idle_minutes);
        return response.status === 200;
    } catch (error) {
        if (error.response?.status !== 401) {
            throw error;
        }
    }
    try {
        await apiClient.post('/auth/refresh');
        const response = await apiClient.get('/check');
        setIdleMinutes(response.data?.session_idle_minutes);
        return response.status === 200;
    } catch (error) {
        return false;
    }
};

export { checkAuth };
